// Default category catalog the material modal's category dropdown shows
// when the org hasn't yet established its own set. Sourced from the
// material-code prefix conventions already in production
// (`formatMaterialCode` uses the category as a prefix). Dev-sync note
// cbf4c002 asked for a "pre-defined" dropdown so operators stop typing
// the same category names slightly differently each time.
//
// Keep this list short. Org-specific categories are surfaced
// automatically by unioning these with the categories already in use on
// existing materials. The form also lets the user add a brand-new one
// inline.

export const DEFAULT_MATERIAL_CATEGORIES: readonly string[] = [
  "general",
  "floor",
  "frame",
  "roof",
  "siding",
  "trim",
  "hardware",
  "fastener",
  "door",
  "window",
  "paint",
  "electrical",
  "plumbing",
];

/**
 * Returns the union of the default catalog with whatever categories the
 * org already uses, sorted case-insensitively. Pure so the form and any
 * future filter UI can share the same suggestion order.
 */
export function buildMaterialCategoryOptions(existing: readonly string[]): string[] {
  const set = new Set<string>();
  for (const c of DEFAULT_MATERIAL_CATEGORIES) {
    const v = c.trim();
    if (v) set.add(v);
  }
  for (const c of existing) {
    const v = c.trim();
    if (v) set.add(v);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
}
